'use client';

import { TiMessages } from 'react-icons/ti';

import { useIntercom } from '@/features/v2/shared/ContactSection/hooks/useIntercom';

import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

const SupportButton = () => {
  const { handleSupportClick } = useIntercom();

  return (
    <div
      className="flex items-center w-full max-w-xs md:mt-4"
    >
      <HButton
        label="Contáctanos"
        onPress={handleSupportClick}
        mode="primary"
        size="large"
        icon={TiMessages}
        iconPosition="start"
        disabled={false}
        fat
      />
    </div>
  );
};

export default SupportButton;
